// extracted by mini-css-extract-plugin
export default {"sidebar-wrapper":"sidebar-wrapper-040f","sidebar":"sidebar-7d6d","sidebar-scrolled":"sidebar-scrolled-3251","move":"move-d985","switchAccountContainer":"switchAccountContainer-3211"};